import React, {useReducer} from 'react';
import {initState, reducer} from "./state/reducer";
import {DispatchContext, StateContext} from "./state/context";
import {AppRouter} from "./router/AppRouter";

export function App() {

    let [state, dispatch] = useReducer(reducer, initState);

    return <div>
        <StateContext.Provider value={state}>
            <DispatchContext.Provider value={dispatch}>
                <AppRouter/>
            </DispatchContext.Provider>
        </StateContext.Provider>
    </div>


}

export default App;
